/* jshint esversion: 6 */
import config from "@/configs/defaultConfigs";
import axios from "@/utils/request";


const actualConfig = config.Z || config;

const app = {
  state: {
    device: 'desktop',
    theme: actualConfig.navTheme,
    language: actualConfig.defaultLocale,
    // scrollHight: 1080, // 1080px
    // 所有角色
    roleList: [],
    // 所有部门
    departmentList: [],
    // 所有用户
    userList: [],
    // 所有字典码
    dictionaryList: [],
    // 所有单位
    unitList: [],
  },
  mutations: {
    TOGGLE_THEME: (state, theme) => {
      state.theme = theme;
    },
    SET_INIT_DATA: (state, { key, value = [] }) => {
      state[key] = Object.freeze(value);
    },
  },
  actions: {
    ToggleTheme({ commit }, theme) {
      commit("TOGGLE_THEME", theme);
    },
    FETCH_ROLE_LIST: ({ commit, state }, force = false) => {
      return new Promise((resolve, reject) => {
        if (!state.roleList || !state.roleList.length || force) {
          axios({
            url: "/manage/role/list",
            method: "GET",
          }).then((response) => {
            if (response.code === 200) {
              commit("SET_INIT_DATA", {
                key: "roleList",
                value: response.list,
              });
              return resolve(response);
            }
            return reject(new Error("加载数据失败"));
          });
        } else {
          return resolve({ code: 200 });
        }
      });
    },
    FETCH_DEPARTMENT_LIST: ({ commit, state }, force = false) => {
      return new Promise((resolve, reject) => {
        if (!state.departmentList || !state.departmentList.length || force) {
          axios({
            url: "/manage/department/list-all",
            method: "POST",
            data: {}
          }).then((response) => {
            if (response.code === 200) {
              commit("SET_INIT_DATA", {
                key: "departmentList",
                value: response.list,
              });
              return resolve(response);
            }
            return reject(new Error("加载数据失败"));
          });
        } else {
          return resolve({ code: 200 });
        }
      });
    },
    // FETCH_USER_LIST: ({ commit, state }, force = false) => {
    //   return new Promise((resolve, reject) => {
    //     if (!state.userList || !state.userList.length || force) {
    //       axios({
    //         url: "/manage/user/list-all",
    //         method: "POST",
    //         data: {},
    //       }).then((response) => {
    //         if (response.code === 200) {
    //           commit("SET_INIT_DATA", {
    //             key: "userList",
    //             value: response.list,
    //           });
    //           return resolve(response);
    //         }
    //         return reject(new Error("加载数据失败"));
    //       });
    //     } else {
    //       return resolve({ code: 200 });
    //     }
    //   });
    // },
    FETCH_DICTIONARY_LIST: ({ commit, state }, force = false) => {
      return new Promise((resolve, reject) => {
        if (!state.dictionaryList || !state.dictionaryList.length || force) {
          axios({
            url: "/manage/dictionary/list",
            method: "GET",
          }).then((response) => {
            if (response.code === 200) {
              commit("SET_INIT_DATA", {
                key: "dictionaryList",
                value: response.list.sort((a, b) => {
                  return b.sort - a.sort;
                }),
              });
              return resolve(response);
            }
            return reject(new Error("加载数据失败"));
          });
        } else {
          return resolve({ code: 200 });
        }
      });
    },
    FETCH_UNIT_LIST: ({ commit, state }, force = false) => {
      return new Promise((resolve, reject) => {
        if (!state.dictionaryList || !state.dictionaryList.length || force) {
          axios({
            url: "/manage/wh-unit/list-all",
            method: "POST",
          }).then((response) => {
            if (response.code === 200) {
              commit("SET_INIT_DATA", {
                key: "unitList",
                value: response.list.sort((a, b) => {
                  return b.sort - a.sort;
                }),
              });
              return resolve(response);
            }
            return reject(new Error("加载数据失败"));
          });
        } else {
          return resolve({ code: 200 });
        }
      });
    },
  },
};

export default app;
